import api from '@/plugins/api'
import notify from '@ananasbear/notify'
import requestValidation from '@/configs/requestValidation'
import { measurement, headersMeasurement } from '@/configs/endpoints'

const store = 'measurement'

export default {
  state: () => ({
    isLoad: false,
    currentStand: '',
    currentDeclaration: '',
    currentTypeMeasurement: 0,
    standStatus: 'standConnect',
    currentError: null,
    selectedStatementType: '',
    historyList: [],
    currentResult: {},
    selectedEquipment: null,
    typeInteraction: null,
    equipmentList: []
  }),
  getters: {
    getLoadStatusMeasurement: state => state.isLoad
  },
  actions: {
    async getEquipmentsList (context, data) {
      const response = await api.get(`${ measurement.inspectionEquipment() }?type_inspection=${data.type_inspection}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'equipmentList', data: response.data })
      }
    },
    async getBrakeEquipmentForCalibration (context) {
      const response = await api.get(measurement.getBrakeEquipmentForCalibration)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'equipmentList', data: response.data })
      }
    },
    setMeasurementInfo (context, data) {
      context.commit('SET_DATA', { store, state: data.item, data: data.body })
    },
    async checkStandStatusInfo (context, stand) {
      const currentStand = context.state.currentStand || stand
      const response = await api.get(measurement.checkStandStatusInfo(currentStand), headersMeasurement)
      if (await requestValidation(response)) return response.data
    },
    async checkStandStatus (context, typeMeasurement) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      let isStartMeasurement = false

      // START GET STANDS
      // якщо сюди приходить наш стенд, то він є онлайн
      const stands = await context.dispatch('getStands')
      const isCurrentStandOnline = stands.find(item => item.id === context.state.currentStand)
      if (!isCurrentStandOnline) {
        context.commit('SET_DATA', { store, state: 'standStatus', data: 'error' })
        context.commit('SET_DATA', {store, state: 'isLoad', data: false})
        notify.error('statusesForStand.standOffline')
      }
      // END GET STANDS

      // START CHECK STAND IS READY
      const checkStandStatusInfo = async () => {
        let timerStandRelease = 10
        return new Promise(resolve => {
          const interval = setInterval(async () => {
            const response = await context.dispatch('checkStandStatusInfo')
            if (response.result?.[0]?.[context.state.currentStand] === 'ready') {
              clearInterval(interval)
              resolve(true)
            }
            if (timerStandRelease !== 0) {
              timerStandRelease--
            } else {
              notify.error('statusesForStand.standNotReadyForMeasurement')
              context.commit('SET_DATA', { store, state: 'standStatus', data: 'error' })
              context.commit('SET_DATA', {store, state: 'isLoad', data: false})
              clearInterval(interval)
              resolve(false)
            }
          }, 1000)
        })
      }
      // END CHECK STAND IS READY
      
      // START CAN YOU START MEASUREMENT
      // typeMeasurement === 'test'
      if (typeMeasurement === 'test') { // for brake test
        let ktzIsPresentOnTheStand = await api.get(
          measurement.checkStandStatus(context.state.currentStand),
          headersMeasurement
        )
        if (!ktzIsPresentOnTheStand.data.status) {
          context.commit('SET_DATA', { store, state: 'standStatus', data: 'error' })
          context.commit('SET_DATA', {store, state: 'isLoad', data: false})
          notify.error('statusesForStand.ktzMissingOnStand')
        }

        isStartMeasurement = !!isCurrentStandOnline && ktzIsPresentOnTheStand.data.status && checkStandStatusInfo()
      } else { // for another test
        isStartMeasurement = !!isCurrentStandOnline
      }
      // END CAN YOU START MEASUREMENT

      return isStartMeasurement
    },
    async runSensorTest(context, data) {
      return new Promise((resolve, reject) => {
        let params = new URLSearchParams()
        params.append('platform', data.side)

        api.get(`${measurement.sensorTest(data)}?${params}`, headersMeasurement)
            .then(() => {
              let checking = setInterval(() => {
                context.dispatch('checkStandStatusInfo', data.id)
                  .then(response => {
                    if (response.result && response.result[0]) {
                      clearInterval(checking)
                      if (response.result[0].result) resolve(response.result[0])
                      else resolve(false)
                    }
                  })
                  .catch(error => {
                    clearInterval(checking)
                    reject(error)
                  })
              }, 2000)
              setTimeout(() => {
                  clearInterval(checking)
                  resolve(false)
              }, 60000)
            })
            .catch(error => reject(error))
      });
    },
    async startMeasurement (context, payload) {
      const isStandReady = await context.dispatch('checkStandStatus', payload.type)
      if (isStandReady) {
        return new Promise(async resolve => {
          // Хз чому так, але додав щоб через 2 сек запускалось. Напевно на беці довго оновлюється і дає помилку
          setTimeout(async () => {
            context.commit('SET_DATA', { store, state: 'isLoad', data: true })
            context.commit('SET_DATA', { store, state: 'standStatus', data: 'testingInProgress' })
            context.commit('SET_DATA', { store, state: 'historyList', data: [] })

            let response = await api.get(measurement.startMeasurement(
                context.state.currentStand,
                payload.declaration,
                payload.type,
                context.state.currentTypeMeasurement,
                payload.params
              ), headersMeasurement)
            
            if (await requestValidation(response)) {
              context.commit('SET_DATA', {store, state: 'standStatus', data: 'testingInProgress'})

              if (response.data.status === 'Finish') {
                // Прибрав (isLoad: false), після того як статус Finish в компонентах тягнемо результат
                // context.commit('SET_DATA', {store, state: 'isLoad', data: false}) 
                context.commit('SET_DATA', {store, state: 'standStatus', data: 'success'})
                resolve(true)
              } else {
                let isMeasurementFinish = false
                const interval = setInterval(async () => {
                  context.dispatch('checkStandStatusInfo')
                    .then(response => {
                      response.result?.forEach(e => {
                        context.commit('ADD_DATA', {store, state: 'historyList', data: e.stage})
                        isMeasurementFinish = e.stage === 'Finish'
                        if (e.stage === 'Finish') {
                          context.commit('SET_DATA', {store, state: 'currentResult', data: e.results})
                          // Прибрав (isLoad: false), після того як  статус Finish в компонентах тягнемо результат
                          // context.commit('SET_DATA', {store, state: 'isLoad', data: false})
                          context.commit('SET_DATA', {store, state: 'standStatus', data: 'success'})
                          clearInterval(interval)
                          resolve(true)
                        }
                      })
                    })
                }, 5000)
                
                // Стенд дає результат через 2хв, якщо ні - то ми релізаємо його, щоб можна було ще раз почати випрробування
                let timerStandRelease = 120
                const timer = setInterval(() => {
                  if (timerStandRelease !== 0) {
                    timerStandRelease--
                  } else if (!isMeasurementFinish) {
                    context.dispatch('standConnect', { id: context.state.currentStand, type: 'release' })
                    context.commit('SET_DATA', { store, state: 'isLoad', data: false })
                    context.commit('SET_DATA', { store, state: 'standStatus', data: 'error' })
                    notify.error('statusesForStand.otherError')
                    clearInterval(timer)
                    clearInterval(interval)
                    resolve(false)
                  }
                }, 1000)
              }
            } else {
              context.commit('SET_DATA', { store, state: 'isLoad', data: false })
              context.commit('SET_DATA', { store, state: 'standStatus', data: 'error' })
              resolve(false)
            }
          }, 2000)
        })
      }
    },
    async turnOffTheStand (context, id) {
      await api.get(measurement.turnOffTheStand(id), headersMeasurement)
    }
  }
}
